import {Pipe, PipeTransform} from '@angular/core';
import {StressLevelEnum} from '../../enums/record';

@Pipe({
  name: 'getImage'
})
export class GetImagePipe implements PipeTransform {

  transform(value: string, type: string): string {
    if (!value) return '';

    switch (type) {
      case 'stressLevel':
        return this.getImageStressLevel(value);
    }
  }

  private getImageStressLevel(value: string): string {
    switch (value) {
      case StressLevelEnum.WITH_OUT_STRESS:
        return 'stress-level-1.png';
      case StressLevelEnum.ALMOST_NO_STRESS:
        return 'stress-level-2.png';
      case StressLevelEnum.LITTLE_STRESS:
        return 'stress-level-3.png';
      case StressLevelEnum.A_LOT_OF_STRESS:
        return 'stress-level-4.png';
      case StressLevelEnum.TOO_MUCH_STRESS:
        return 'stress-level-5.png';
      default:
        return 'stress-level-1.png';
    }
  }

}
